import { IPage } from '@aon/aon-tws-common-ui';
import axios from 'axios';
import Constants from '../constants';
import { IDistributionContact } from '../models';

export function getParticipantsQuery(surveyId: number, audienceId: number) {
	const params = Constants.SURVEY_BUILDER_SURVEYS_API_URL + `/${surveyId}/audiences/${audienceId}/surveyparticipants`;

	return params;
}

export function getPagedSurveyParticipantsQuery(surveyId: number, audienceId: number) {
	let params = `${Constants.SURVEY_BUILDER_SURVEYS_API_URL}/${surveyId}/audiences/${audienceId}/surveyparticipants/`;
	params += 'paged';

	return params;
}

export async function getSurveyParticipants(
	surveyId: number,
	audienceId: number,
	offSet: number,
	limit: number,
	searchText: string,
	sortedBy: string,
	sortAsc: boolean,
	selectedColumns?: string[],
	selectedDistributionContactIds?: number[],
	getOnlyDuplicates?: boolean,
): Promise<IPage<IDistributionContact>> {
	const res = await axios.post(getPagedSurveyParticipantsQuery(surveyId, audienceId), {
		offSet,
		limit,
		sortedOn: sortedBy,
		sortAsc,
		searchText,
		columns: selectedColumns ? selectedColumns.join(',') : undefined,
		selectedDistributionContactIds,
		getOnlyDuplicates,
	});

	return {
		pageRange: JSON.parse(res.headers.range),
		items: res.data,
	};
}

export async function Resend(surveyId: number, audienceId: number, distributionContactIds: number[]): Promise<string> {
	const res = await axios.post(getParticipantsQuery(surveyId, audienceId) + '/resend', {
		audienceId,
		distributionContactIds,
	});
	return res.data;
}

export async function Reopen(surveyId: number, audienceId: number, distributionContactIds: number[], resend: boolean): Promise<string> {
	const res = await axios.post(getParticipantsQuery(surveyId, audienceId) + '/reopen', {
		audienceId,
		distributionContactIds,
		resend,
	});
	return res.data;
}

export async function Reset(surveyId: number, audienceId: number, distributionContactIds: number[], resend: boolean): Promise<string> {
	const res = await axios.post(getParticipantsQuery(surveyId, audienceId) + '/reset', {
		audienceId,
		distributionContactIds,
		resend,
	});
	return res.data;
}

export async function getSurveyParticipantsCount(
	surveyId: number,
	audienceId: number,
	searchText: string,
	getOnlyDuplicates?: boolean,
): Promise<number> {
	const res = await axios.get(
		`${getParticipantsQuery(surveyId, audienceId)}` + `/count?searchText=${searchText}&getOnlyDuplicates=${getOnlyDuplicates}`,
	);

	return res.data;
}
